import { render, staticRenderFns } from "./DialogRemovePlayerFromGroup.vue?vue&type=template&id=c18d78e6&scoped=true"
import script from "./DialogRemovePlayerFromGroup.js?vue&type=script&lang=js&external"
export * from "./DialogRemovePlayerFromGroup.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18d78e6",
  null
  
)

export default component.exports